import { flow, makeObservable, action, observable, computed } from 'mobx';
import { GlobalStore, ApiResponse } from '@roc/feature-app-core';
import { LoanStore } from '@roc/feature-loans';
import { PointOfContactService } from '../../../services/documentForms/pointOfContactService';
import { PointOfContactFormStore } from './pointOfContactFormStore';

export enum PointOfContactType {
  DRAWS = 'DRAWS',
  INTERNAL_VALUATION = 'INTERNAL_VALUATION',
  SITE_INPECTION = 'SITE_INSPECTION'
}

export class PointOfContactStore {
  globalStore: GlobalStore;
  loanStore: LoanStore;
  pointOfContactFormStore: PointOfContactFormStore;
  pointOfContactsList: any[];
  showAllFormValues: boolean = true;
  private pointOfContactService: PointOfContactService;
  isNewPointFormOfContactOpen: boolean = false;
  pointOfContacts: any[] = [];
  lenderInfo?: any;

  constructor(globalStore, loanStore) {
    this.globalStore = globalStore;
    this.loanStore = loanStore;
    this.pointOfContactFormStore = new PointOfContactFormStore(globalStore);
    this.pointOfContactService = new PointOfContactService();
    this.pointOfContactsList = [];
    makeObservable(this, {
      savePointOfContact: flow,
      getPointOfContactsList: flow,
      pointOfContacts: observable,
      isNewPointFormOfContactOpen: observable,
      pointOfContactsList: observable,
      setIsNewPointOfContactOpen: action,
      showAllFormValues: observable,
      resetStore: action,
      pointOfContactFormStore: observable,
      lenderInfo: observable,
    });
  }
  setIsNewPointOfContactOpen(value: boolean) {
    this.isNewPointFormOfContactOpen = value;
  }
  selectPointOfContact(pointOfContactId: number) {
    this.pointOfContactFormStore.onFieldChange(
      'pointOfContactId',
      pointOfContactId
    );
    this.resetPointOfContactData();
    if (pointOfContactId) {
      const poc = this.pointOfContacts.find(
        poc => poc.pointOfContactId === pointOfContactId
      );
      this.pointOfContactFormStore.loadForm(poc);
    }
  }
  resetPointOfContactData() {
    this.pointOfContactFormStore.form.fields.firstName.value = '';
    this.pointOfContactFormStore.form.fields.lastName.value = '';
    this.pointOfContactFormStore.form.fields.phoneNumber.value = '';
    this.pointOfContactFormStore.form.fields.email.value = '';
    this.pointOfContactFormStore.form.fields.comments.value = '';
  }
  loadPointOfContact(pointOfContact: any) {
    this.pointOfContactFormStore.loadForm({
      pointOfContactId: pointOfContact.pointOfContactId,
      firstName: pointOfContact.firstName,
      lastName: pointOfContact.lastName,
      phoneNumber: pointOfContact.phone,
      email: pointOfContact.email,
      comments: '',
    });
  }
  *getPointOfContactsList(loanId: number, type: string) {
    try {
      const response: ApiResponse = yield this.pointOfContactService.getPointOfContactsByLoanId(
        loanId, type
      );
      this.pointOfContactsList = response.data?.data || [];
    } catch (e) {
      console.log(e);
    }
  }

  *savePointOfContact(loanId: number, pointOfContact, type) {
    try {
      const resp = yield this.pointOfContactService.assignTask({ ...pointOfContact, loanId });
      if (resp?.data?.status === "OK") {
        this.isNewPointFormOfContactOpen = false;
        this.pointOfContactFormStore.resetStore();
        yield this.getPointOfContactsList(this.loanStore?.loanDetails?.loanId, type);
      }
    } catch (e) {
      console.error('Error saving point of contact:', e);
    }
  }
  resetStore = () => {
    this.pointOfContactFormStore.resetStore();
  }
}
